var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "4 4 15 15"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "check_icon",
  d: "M15.22 8.357c.344-.41.973-.477 1.405-.148a.92.92 0 0 1 .156 1.337L11.355 16l-3.981-3.044a.92.92 0 0 1-.153-1.338c.345-.41.975-.475 1.405-.146l2.42 1.85z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  fill: "#818490",
  xlinkHref: "#check_icon"
})));
export default SvgCheck;